import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=1cfb6a27&"
import script from "./QR.vue?vue&type=script&lang=ts&"
export * from "./QR.vue?vue&type=script&lang=ts&"
import style0 from "./QR.vue?vue&type=style&index=0&id=1cfb6a27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports